export default __webpack_public_path__ + "static/cloud-hosting-amico-c3c163a353525398b579b30c470ac974.svg";